export default __webpack_public_path__ + "static/media/PDF.87f8de1c.svg";